export default __webpack_public_path__ + "static/media/suspicious-covid.bb17993a.svg";